export function formatTelephoneForFront( telephone ) {
    if( telephone.length == 13 ) { //Número fixo
        return `(${telephone.substring(3,5)}) ${telephone.substring(5,9)}-${telephone.substring(9)}`
    } else { //Celular
        return `(${telephone.substring(3,5)}) ${telephone.substring(5,6)} ${telephone.substring(6,10)}-${telephone.substring(10)}`
    }
}

export function formatTelephoneForUrl( telephone ) {
    let part1 = telephone.substring(1, 3);
    let part2 = telephone.substring(5, 6);
    let part3 = telephone.substring(7, 11);
    let part4 = telephone.substring(12);

    return `+55${part1}${part2}${part3}${part4}`;
}

export function removeMaskOfTelephone( telephone ) {
    let part1 = telephone.substring(1, 3);
    let part2 = telephone.substring(5, 6);
    let part3 = telephone.substring(7, 11);
    let part4 = telephone.substring(12);

    return `${part1}${part2}${part3}${part4}`
}